import { Col, Collapse, Row, Skeleton, Typography } from "antd";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "../ServerSideStates";
import { useEffect, useState } from "react";
import { Color } from "antd/es/color-picker";

const CollapseItems = () => {
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(advertId);
  const { Text } = Typography;
  const { Panel } = Collapse;

  function  handleFormattedDBOptions (optionList: any[]) {
    const formattedOptionsList: any[] = [];
    const multipleSelectMap: Record<number, any> = {}; // multiple-select için gruplayıcı
  
    for (let opItem of optionList) {
      if (opItem?.type === 1) {
        formattedOptionsList.push({
          name: opItem.optionName,
          value: opItem.selectedValue,
          type: "input",
          key: opItem.optionId,
        });
      } else if (opItem?.type ===2) {
        formattedOptionsList.push({
          name: opItem.optionName,
          value: {
            name: opItem.optionValueName,
            value: opItem.optionValueId,
            type: "select",
            key: opItem.optionValueId,
          },
          key: opItem.optionId,
        });
      } else if (opItem?.type === 3) {
        if (!multipleSelectMap[opItem.optionId]) {
          multipleSelectMap[opItem.optionId] = {
            name: opItem.optionName,
            values: [],
            key: opItem.optionId,
          };
        }
        multipleSelectMap[opItem.optionId].values.push({
          name: opItem.optionValueName,
          value: opItem.selectedValue,
          key: opItem.optionValueId,
        });
      }
    }
  
    // Multiple select olanları listeye ekleyelim
    formattedOptionsList.push(...Object.values(multipleSelectMap));
  
    return formattedOptionsList;
  }

  const [optionsData, setOptionsData] = useState<any>(null);
  useEffect(() => {
    if (advertDetails?.data?.data) {
      const detailsData = advertDetails.data.data;
      const options =handleFormattedDBOptions(detailsData?.advertOptionAttr) ;
 
      if (options) {
        setOptionsData(options);
      }
    }
  }, [advertDetails.data]);

  return (
    <>
   <Skeleton loading={advertDetails.isLoading || advertDetails.isFetching} >
    {
      optionsData&&<>
        <Collapse
           defaultActiveKey={optionsData.map((item:any)=>item?.name)}
          className="!rounded-lg"
        >
        {optionsData?.map
          ? optionsData
              .filter((item: any) => item?.values)
              .map((item: any) => {
                return (
                  <>
                    <Panel
                      header={
                        <Text className="!text-lg !text-black">
                          {item.name}
                        </Text>
                      }
                      key={item.name}
                      className="!bg-[#f4f4f4]"
                    >
                        <Col xs={24} >
                            <Row gutter={[20,20]} >
                                {
                                    item?.values?.map?item.values.map((subItem:any)=>{
                                    return(
                                        <Col xs={24} md={12} lg={6}>
                                          <span style={{color: 'blue'}}>•</span>  <Text className="!text-indigo-500 ">{subItem?.name}</Text>
                                        </Col>
                                    )
                                    }):[]
                                }
                            </Row>
                        </Col>
                    </Panel>
                  </>
                );
              })
          : []}

        </Collapse>
      </>
    }

   </Skeleton>
     
   
    </>
  );
};

export default CollapseItems;
